// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2kCHU","footer":"ModalError_footer__1pj7m"};